import React from 'react';
import { Helmet } from 'react-helmet';
import { useLocation } from 'react-router-dom';

const MetaTags = props => {
	const location = useLocation();
	const { title, desc, img, noFollow } = props;
	const descClean = desc ? desc.replace(/\n/g, ' ') : '';
	const tit = 'MEBlabs - ' + title.replace(/\n/g, ' ');

	return noFollow ? (
		<Helmet>
			<title>{tit}</title>
			<meta name="robots" content="noindex,nofollow" />
			<meta name="googlebot" content="noindex,nofollow" />
		</Helmet>
	) : (
		<Helmet>
			<title>{tit}</title>
			<meta name="description" content={descClean} />
			<meta itemProp="name" content={tit} />
			<meta itemProp="image" content={img} />
			<meta itemProp="description" content={descClean} />
			<meta name="twitter:card" content="summary_large_image" />
			<meta name="twitter:title" content={tit} />
			<meta name="twitter:description" content={descClean} />
			<meta property="og:title" content={tit} />
			<meta property="og:type" content="website" />
			<meta property="og:url" content={process.env.REACT_APP_URL + location.pathname} />
			<meta property="og:description" content={descClean} />
			<meta property="og:image" content={img} />
			<meta property="og:site_name" content="MEBlabs" />
		</Helmet>
	);
};

export default MetaTags;
